const action = "MODEL_DETAIL";
export const REQUEST = action+'_REQUEST';
export const RESPONSE = action+'_RESPONSE';
export const CLEAR = action+'_CLEAR';
export const FAILURE = action+'_FAILURE';
export const APPEND_TRAININGS = action+'_APPEND_TRAININGS';

export const fetchRequest = (modelId, options = {}) => {
    return {
        type: REQUEST,
        payload: { modelId, options }
    };
};

export const fetchSuccess = (response, options = {}) => ({
  type: options.append_trainings ? APPEND_TRAININGS : RESPONSE,
  payload: response,
  options
});

export const clearState = () => ({
  type: CLEAR
});

export const fetchFailure = (error) => ({
  type: FAILURE,
  payload: error
});

export const getModelDetail = (modelId, options = {}) => {
  return fetchRequest(modelId, options);
}; 